module.exports = __webpack_public_path__ + "img/impostor-test.11c5026e.png";